import { Icon } from "@mui/material";
import { ReactNode } from "react";

import { Episode } from "../../shared/types/Episode";
import "../css/Reader.css";

type Props = {
  episode?: Episode;
  progress?: number;
  action?: ReactNode;
  onExit: () => void;
};

const ReaderTopbar = (props: Props) => {
  const { episode, progress, action, onExit } = props;

  return (
    <header className="rd-topbar">
      <button type="button" className="rd-icon-btn" onClick={onExit} aria-label="Quitter la lecture et revenir à la série">
        <Icon>arrow_back</Icon>
      </button>

      <div className="rd-topbar__title">
        {episode ? (
          <>
            <span className="rd-topbar__ep">Épisode {episode.number}</span>
            <span className="rd-topbar__name">{episode.name}</span>
          </>
        ) : null}
      </div>

      {action}
      <span className={`rd-topbar__spacer${action ? " rd-topbar__spacer--settings" : ""}`} aria-hidden="true" />

      {progress !== undefined ? (
        <div
          className="rd-progress"
          role="progressbar"
          aria-label="Progression de la lecture"
          aria-valuemin={0}
          aria-valuemax={100}
          aria-valuenow={Math.round(progress * 100)}
        >
          <span style={{ transform: `scaleX(${progress})` }} />
        </div>
      ) : null}
    </header>
  );
};

export default ReaderTopbar;
